import { Button, Form, Input } from "antd";
import React, { useState } from "react";
import { withNamespaces } from "react-i18next";
import { useNavigate } from "react-router-dom";

import { Link } from "../styles/Design";

const { Item } = Form;
const ForgotPasswordForm = ({ t, setFormType }) => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    emailOrPhoneNumber: "",
  });
  const onSubmit = (data) => {
    navigate("/auth/verification", {
      state: {
        data: data.emailOrPhoneNumber,
      },
    });
    return window.location.reload();
  };
  const onChange = (e) => {
    setFormData((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));
  };

  return (
    <>
      <Form onFinish={onSubmit} style={{ width: "70%", marginBottom: "2rem" }}>
        <Item
          name="emailOrPhoneNumber"
          rules={[
            {
              required: true,
              message: "Please input your email!",
            },
          ]}
        >
          <Input
            value={formData.emailOrPhoneNumber}
            size="large"
            placeholder={t("pages.auth.emailOrPhoneNumber")}
            onChange={onChange}
          />
        </Item>
        <Button
          type="primary"
          htmlType="submit"
          style={{
            width: "100%",
            fontWeight: "500",
            fontSize: "16px",
            backgroundColor: "#012F6B",
            borderRadius: "5px",
            border: "none",
          }}
          size="large"
        >
          {t("pages.auth.requestPasswordChange")}
        </Button>
      </Form>
      <div>
        <p style={{ fontSize: "14px", fontWeight: "400" }}>{t("pages.auth.needHelp")}</p>
        <Link type="secondary" to="/support">
        {t("pages.auth.customerSupport")}
        </Link>
      </div>
    </>
  );
};

export default withNamespaces()(ForgotPasswordForm);
